import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/images/ws-creation-success-image.png'


const _withScopeId = n => (_pushScopeId("data-v-3ff8d729"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-flex tw-items-center tw-justify-end tw-p-4" }
const _hoisted_2 = { class: "main tw-w-full tw-h-full tw-pt-2 rmd:tw-pt-4" }
const _hoisted_3 = { class: "custom__modal__content tw-h-full" }
const _hoisted_4 = { class: "custom__modal__content__wrapper !tw-h-full soletrader__content__wrapper tw-gap-4" }
const _hoisted_5 = {
  key: 0,
  class: "custom__modal__content__wrapper__top tw-h-full tw-flex tw-flex-col tw-justify-between rmd:tw-w-[50%]"
}
const _hoisted_6 = { class: "custom__modal__sub__content tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Preferred / Trading As Name", -1))
const _hoisted_9 = {
  key: 1,
  class: "custom__modal__content__wrapper__top tw-h-full tw-flex tw-flex-col tw-justify-between rmd:tw-w-[50%]"
}
const _hoisted_10 = { class: "custom__modal__sub__content" }
const _hoisted_11 = { class: "uploade-wrapper solo-trader-uploade-wrapper md:!tw-my-[25px] md:!tw-mx-[auto]" }
const _hoisted_12 = { class: "uploade-wrapper md:!tw-my-[25px] md:!tw-mx-[auto] md:!tw-w-full md:!tw-h-full md:!tw-flex md:!tw-flex-col md:!tw-items-center md:!tw-justify-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  key: 2,
  class: "custom__modal__inner__content tw-overflow-y-auto tw-px-2 tw-box-border tw-pb-2"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "check-list" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Build trust with a Verified iknowa Trade Passport "),
  /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Enjoy 100MB of storage for documents and files "),
  /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Bid on unlimited jobs & win new clients "),
  /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Cancel your plan anytime if you're not satisfied "),
  /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " After setting up your workstation, you can add members and pay £9.99 per month/ user ")
], -1))
const _hoisted_16 = { class: "plan-cards" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-card__tags" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "plan-card__tag-item" }, "YEARLY"),
  /*#__PURE__*/_createElementVNode("span", { class: "plan-card__tag-item-discount" }, "20% Discount")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "plan-card__price" }, [
  /*#__PURE__*/_createElementVNode("span", null, "£7.99"),
  /*#__PURE__*/_createTextVNode(" per month/ £95.90 today ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-card__tags" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "plan-card__tag-item" }, "MONTHLY")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "plan-card__price" }, [
  /*#__PURE__*/_createElementVNode("span", null, "£9.99"),
  /*#__PURE__*/_createTextVNode(" per month")
], -1))
const _hoisted_21 = {
  key: 3,
  class: "custom__modal__inner__content tw-flex tw-flex-col tw-gap-4 rmd:!tw-gap-6"
}
const _hoisted_22 = { class: "tw-w-full tw-h-auto tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4" }
const _hoisted_23 = { class: "tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "check-list" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
    /*#__PURE__*/_createTextVNode(" Access Subsidised "),
    /*#__PURE__*/_createElementVNode("strong", null, "Upskilling"),
    /*#__PURE__*/_createTextVNode(" Courses ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
    /*#__PURE__*/_createTextVNode(" Find & Estimate on "),
    /*#__PURE__*/_createElementVNode("strong", null, "New Jobs")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
    /*#__PURE__*/_createTextVNode(" Collaborate With "),
    /*#__PURE__*/_createElementVNode("strong", null, "Your Team"),
    /*#__PURE__*/_createTextVNode(" or "),
    /*#__PURE__*/_createElementVNode("strong", null, "Other Trades")
  ])
], -1))
const _hoisted_25 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-4" }
const _hoisted_26 = { class: "tw-flex-row-between" }
const _hoisted_27 = { class: "tw-rounded-[4px] tw-border-solid tw-border-[#FAA500] tw-border-[1px] tw-flex tw-items-center tw-justify-center tw-py-[2px] tw-px-[6px] tw-box-border" }
const _hoisted_28 = { class: "tw-rounded-[4px] tw-bg-[#FAA500] tw-flex tw-items-center tw-justify-center tw-py-[2px] tw-px-[6px] tw-box-border" }
const _hoisted_29 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-2 rmd:!tw-flex-row rmd:!tw-items-end" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "£95.88", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "billed today", -1))
const _hoisted_32 = { class: "tw-flex-row-between" }
const _hoisted_33 = { class: "tw-rounded-[4px] tw-border-solid tw-border-[#FAA500] tw-border-[1px] tw-flex tw-items-center tw-justify-center tw-py-[2px] tw-px-[6px] tw-box-border" }
const _hoisted_34 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full tw-items-start rmd:!tw-flex-row-between rmd:!tw-flex-row" }
const _hoisted_35 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-2 rmd:!tw-flex-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "billed today", -1))
const _hoisted_37 = { class: "tw-flex tw-items-center tw-justify-center tw-rounded-[4px] tw-bg-[#EAEBF7] tw-px-[8px] tw-py-[3px] tw-box-border" }
const _hoisted_38 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center tw-mt-2" }
const _hoisted_39 = {
  key: 5,
  class: "tw-flex tw-flex-col tw-gap-3"
}
const _hoisted_40 = { class: "tw-flex tw-flex-col tw-gap-4 rmd:tw-gap-10" }
const _hoisted_41 = { class: "header-title !tw-capitalize" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-sub-title" }, " You have successfully created your Trade Workstation. ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom__modal__img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Create Workstation"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_TpIcon = _resolveComponent("TpIcon")!
  const _component_TermsAndCondition = _resolveComponent("TermsAndCondition")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_WizardModal = _resolveComponent("WizardModal")!
  const _component_commonDialog = _resolveComponent("commonDialog")!
  const _component_PaymentStatusModal = _resolveComponent("PaymentStatusModal")!
  const _component_KYCStatusModal = _resolveComponent("KYCStatusModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowSoleTraderWorkStationModal)
      ? (_openBlock(), _createBlock(_component_WizardModal, {
          key: 0,
          steps: $setup.tabListItems,
          currentStep: $setup.getActiveSoleTraderWorkStationModal,
          onOnBack: $setup.onClickBackButton,
          onOnClose: $setup.onHandleClickClose,
          hideBackButton: 
      $setup.getActiveSoleTraderWorkStationModal >= 6 &&
      $setup.activeUserWorkstation.subscription
    ,
          hasCustomHeader: 
      $setup.isPersonalAccountWorkStation &&
      $setup.isFromCourse &&
      $setup.getActiveSoleTraderWorkStationModal === 4
    ,
          hideTitleAndDescription: 
      $setup.isPersonalAccountWorkStation &&
      $setup.isFromCourse &&
      $setup.getActiveSoleTraderWorkStationModal === 4
    
        }, {
          "custom-header": _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_icon, {
                icon: "mdi-close",
                class: "tw-cursor-pointer",
                onClick: $setup.onHandleClickClose
              }, null, 8, ["onClick"])
            ])
          ]),
          content: _withCtx(() => [
            _createElementVNode("main", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  ($setup.currentSelectedTab?.name === 'traderInfo')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_form, {
                            rules: $setup.validation,
                            ref: "tradingNameRef"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createVNode(_component_v_text_field, {
                                  rules: $setup.validation.tradingName,
                                  density: "compact",
                                  placeholder: "E.g. Sparks Buildings",
                                  modelValue: $setup.tradingName,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tradingName) = $event)),
                                  variant: "outlined",
                                  class: "c-input rounded-full"
                                }, null, 8, ["rules", "modelValue"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["rules"])
                        ]),
                        _createVNode(_component_Button, {
                          label: "continue",
                          onClick: $setup.onClickContinue,
                          isActive: $setup.tradingName.length,
                          class: "button disable",
                          isLoading: $setup.isWorkStationCreated
                        }, null, 8, ["onClick", "isActive", "isLoading"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.currentSelectedTab?.name === 'profile')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_v_file_input, {
                                class: _normalizeClass(["upload_file md:!tw-w-[150px] md:!tw-h-[150px] md:!tw-mb-0", { 'added-img': $setup.imageUrl }]),
                                accept: "image/png, image/jpeg",
                                "append-inner-icon": "mdi-image-plus",
                                variant: "solo-filled",
                                onChange: $setup.onFileChange,
                                "onClick:clear": $setup.clearImageUrl
                              }, null, 8, ["onChange", "onClick:clear", "class"]),
                              _createVNode(_component_v_img, {
                                class: "uploaded-img md:!tw-w-[150px] md:!tw-h-[150px] md:!tw-left-[unset]",
                                width: 200,
                                "aspect-ratio": "16/9",
                                cover: "",
                                src: $setup.imageUrl
                              }, null, 8, ["src"]),
                              _createVNode(_component_Text, {
                                variant: "p",
                                textAlign: "center",
                                textColor: "rgba(255, 0, 0,0.5)"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.fileUploadErrorMsg), 1)
                                ]),
                                _: 1
                              }),
                              _hoisted_13,
                              _createVNode(_component_Text, {
                                variant: "span",
                                textAlign: "center",
                                textColor: "rgba(12, 15, 74, 0.5)",
                                whiteSpace: "nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Accepted file formats: PNG, JPEG")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createVNode(_component_Button, {
                          label: "continue",
                          onClick: $setup.onClickContinueSaveLogoAndName,
                          isActive: $setup.imageUrl.length,
                          isLoading: $setup.isWorkStationCreated
                        }, null, 8, ["onClick", "isActive", "isLoading"])
                      ]))
                    : _createCommentVNode("", true),
                  (
                $setup.currentSelectedTab?.name === 'subscription' && !$setup.isFromCourse
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_v_card, { class: "plan-card" }, {
                            default: _withCtx(() => [
                              _hoisted_17,
                              _hoisted_18,
                              _createVNode(_component_v_btn, {
                                class: "button button-orange w-full",
                                loading: $setup.yearlyPlanLoading,
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickPaymentPlan($setup.PaymentPlanType.YEARLY)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Choose YEARLY")
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card, { class: "plan-card" }, {
                            default: _withCtx(() => [
                              _hoisted_19,
                              _hoisted_20,
                              _createVNode(_component_v_btn, {
                                class: "button button-orange w-full",
                                loading: $setup.monthlyPlanLoading,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickPaymentPlan($setup.PaymentPlanType.MONTHLY)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Choose MONTHLY")
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.currentSelectedTab?.name === 'subscription' && $setup.isFromCourse)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_TpIcon),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_Text, {
                              variant: "h3",
                              textAlign: "center",
                              lineHeight: "18px"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Select Your Plan")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Text, {
                              variant: "p",
                              textColor: "rgba(12, 15, 74, 0.5)",
                              textAlign: "center",
                              lineHeight: "18px"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("...and Unlock Your Trade Superpower Today")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.selectSubscriptionType('yearly'))),
                              class: _normalizeClass([{
                      '!tw-border-[#FAA500]':
                        $setup.selectedSubscriptionType === 'yearly',
                    }, "tw-rounded-[16px] tw-border-solid tw-border-[rgba(12,15,74,0.2)] tw-border-[2px] tw-w-full tw-flex tw-flex-col tw-gap-4 tw-p-4 tw-box-border tw-cursor-pointer"])
                            }, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_Text, { variant: "p" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("YEARLY")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_Text, {
                                    variant: "p",
                                    textColor: "#fff",
                                    textWeight: "400"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Most Cost Effective")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_Text, { variant: "h3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("£7.99")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Text, {
                                  variant: "h6",
                                  textWeight: "400"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("per month / "),
                                    _hoisted_30,
                                    _createTextVNode(" (+ VAT) "),
                                    _hoisted_31
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 2),
                            _createElementVNode("div", {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.selectSubscriptionType('quarterly'))),
                              class: _normalizeClass([{
                      '!tw-border-[#FAA500]':
                        $setup.selectedSubscriptionType === 'quarterly',
                    }, "tw-rounded-[16px] tw-border-solid tw-border-[rgba(12,15,74,0.2)] tw-border-[2px] tw-w-full tw-flex tw-flex-col tw-gap-4 tw-p-4 tw-box-border tw-cursor-pointer"])
                            }, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_Text, { variant: "p" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("3-MONTHS")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_component_Text, { variant: "h3" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("£9.99")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Text, {
                                    variant: "h6",
                                    textWeight: "400"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("per month / "),
                                      _createElementVNode("strong", null, _toDisplayString($setup.CurrencyFilter.formatToCurrency(
                              $setup.spotsAmount.toString()
                            )), 1),
                                      _createTextVNode(" (+ VAT) "),
                                      _hoisted_36
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(_component_Text, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Total " + _toDisplayString($setup.numberOfSpotsReserved) + " Spots (3 Months x £9.99)", 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ], 2),
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_Button, {
                                class: "tw-my-6",
                                label: "take me to payment",
                                loading: $setup.monthlyPlanLoading || $setup.yearlyPlanLoading,
                                onClick: $setup.onSubscribe
                              }, null, 8, ["loading", "onClick"]),
                              _createVNode(_component_Text, {
                                variant: "span",
                                textColor: "rgba(12, 15, 74, 0.5)"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Cancel Anytime After 3 Months | "),
                                  _createVNode(_component_Text, {
                                    variant: "span",
                                    textColor: "#FAA500"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Terms & Conditions")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.currentSelectedTab?.name === 'termCondition')
                    ? (_openBlock(), _createBlock(_component_TermsAndCondition, { key: 4 }))
                    : _createCommentVNode("", true),
                  ($setup.currentSelectedTab?.name === 'termCondition')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_checkbox, {
                            modelValue: $setup.acceptAggreement,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.acceptAggreement) = $event)),
                            label: "I accept & agree to the Terms of Service"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_Button, {
                            class: "rmd:!tw-w-[400px]",
                            label: "continue",
                            onClick: $setup.goToNextTab,
                            isActive: $setup.acceptAggreement
                          }, null, 8, ["onClick", "isActive"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["steps", "currentStep", "onOnBack", "onOnClose", "hideBackButton", "hasCustomHeader", "hideTitleAndDescription"]))
      : _createCommentVNode("", true),
    _createVNode(_component_commonDialog, {
      modelValue: $setup.isShowSuccessfullModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.isShowSuccessfullModal) = $event)),
      isShowHeader: false,
      isShowBackButton: false,
      width: "465px",
      "max-width": "100%",
      height: "auto",
      persistent: "",
      className: ['solo-trader__last__step__box', 'workstation_create_modal']
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_41, [
              _createTextVNode(" Great job, "),
              _createElementVNode("span", null, _toDisplayString($setup.activeUserWorkstation?.user?.firstName ||
                $setup.activeUserWorkstation?.name), 1)
            ]),
            _hoisted_42
          ]),
          _hoisted_43,
          _createVNode(_component_Text, {
            variant: "h6",
            textWeight: "400",
            textColor: "rgba(12, 15, 74, 0.5)"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Time to take your business sky high and supercharge your skills! Start by completing your Trade Passport.")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_btn, {
          class: "button button-orange !tw-mt-[16px] rmd:!tw-mt-[24px]",
          size: "large",
          block: "",
          onClick: $setup.onClickSoloTraderDashboard
        }, {
          default: _withCtx(() => [
            _createTextVNode(" continue 🚀 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    ($setup.statusModal.PAYMENT === $setup.currentStatusModalName)
      ? (_openBlock(), _createBlock(_component_PaymentStatusModal, {
          key: 1,
          onContinue: $setup.onClickStatusModalContinue,
          paymentStatus: $setup.currentModalStatus,
          planType: $setup.planType
        }, null, 8, ["onContinue", "paymentStatus", "planType"]))
      : _createCommentVNode("", true),
    ($setup.statusModal.KYC === $setup.currentStatusModalName)
      ? (_openBlock(), _createBlock(_component_KYCStatusModal, {
          key: 2,
          onContinue: $setup.onClickTermAndConditionNext,
          kycStatus: $setup.currentModalStatus
        }, null, 8, ["onContinue", "kycStatus"]))
      : _createCommentVNode("", true)
  ], 64))
}